/**
 * Renovatech — empresa de reformas.
 * El panel completo (CRM, obras, calculadora, finanzas, Meta) vive en su propio
 * servicio y se embebe aquí mismo. También accesos directos a pantalla completa.
 */
function h(tag, attrs = {}, children = []) {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs || {})) {
    if (v == null || v === false) continue;
    if (k === 'class') el.className = v;
    else if (k === 'style') el.style.cssText = v;
    else if (k === 'html') el.innerHTML = v;
    else if (k.startsWith('on') && typeof v === 'function') el.addEventListener(k.slice(2).toLowerCase(), v);
    else if (v === true) el.setAttribute(k, '');
    else el.setAttribute(k, v);
  }
  for (const c of [].concat(children)) {
    if (c == null || c === false) continue;
    el.appendChild(typeof c === 'string' || typeof c === 'number' ? document.createTextNode(String(c)) : c);
  }
  return el;
}

const PANEL_EMBED = 'https://renovatech.carlos-os1.duckdns.org/';
const PANEL_FULL = 'https://panel.renovatechsl.com/';
const WEB_PUBLICA = 'https://renovatechsl.com/';

export function renderRenovatech(root, ctx) {
  root.innerHTML = '';

  const linkBtn = (label, href, primary) => h('a', {
    href, target: '_blank', rel: 'noopener noreferrer',
    class: 'inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition ' +
      (primary ? 'bg-gold-400 text-base-900 hover:bg-gold-300' : 'bg-base-800 text-ink-100 border border-base-700 hover:border-gold-400/50'),
  }, label);

  const head = h('div', { class: 'flex items-center justify-between gap-3 mb-4 flex-wrap' }, [
    h('div', {}, [
      h('h2', { class: 'font-display text-3xl font-bold' }, [h('span', {}, '🔧 '), 'Renovatech']),
      h('p', { class: 'text-ink-300 text-sm mt-1' }, 'Panel de gestión de reformas: CRM, obras, presupuestos, finanzas y Meta.'),
    ]),
    h('div', { class: 'flex items-center gap-2 flex-wrap' }, [
      linkBtn('⛶ Pantalla completa', PANEL_FULL, true),
      linkBtn('🌐 Web pública', WEB_PUBLICA, false),
      h('button', {
        class: 'inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm bg-base-800 text-ink-200 border border-base-700 hover:border-gold-400/50 transition',
        title: 'Recargar el panel',
        onclick: () => { const f = document.getElementById('renovatech-frame'); if (f) f.src = f.src; },
      }, '↻'),
    ]),
  ]);

  // Aviso de login (solo la primera vez se ve el login dentro del iframe)
  const hint = h('div', { class: 'text-xs text-ink-400 mb-3' },
    'Si te pide acceso, entra una vez dentro del recuadro y la sesión se queda guardada.');

  const frameWrap = h('div', {
    class: 'rounded-2xl overflow-hidden border border-base-700 bg-base-900',
    style: 'box-shadow:0 0 30px -12px rgba(77,166,255,.35);',
  }, [
    h('iframe', {
      id: 'renovatech-frame',
      src: PANEL_EMBED,
      allow: 'clipboard-write; fullscreen',
      style: 'width:100%; height:calc(100vh - 230px); min-height:560px; border:0; display:block; background:#0B1222;',
    }),
  ]);

  root.appendChild(head);
  root.appendChild(hint);
  root.appendChild(frameWrap);
}
